// Multiple controllers have the ability to share a listing.  This allows them all to use common code.
export function shareListing(evt) {
  // User wants to display the share page
  evt.preventDefault();

  const isAgent = Flexmls.currentUser.role == 'private';

  // This is what we want to load into the turbo-frame
  let goingToUrl = new URL(evt.target.href)
  goingToUrl.searchParams.set('flexpanel',true)


  let listingId = $(evt.target).attr('data-listing-id');

  if (!isAgent) {
    goingToUrl.searchParams.set('consumer_share', true);

    window.dispatchEvent(new CustomEvent("display-remote-modal", {
      detail: {
        modalHeader: `<div class="t-title--large">Share Listing</div>`,
        modalCssClasses: "modal-dialog c-modal modal-sm",
        modalContentCssClasses: "consumer-share-modal",
        modalRemote: goingToUrl.href,
      }
    }));
  } else {
    window.dispatchEvent(new CustomEvent("display-remote-modal", {
      detail: {
        modalHeader: `<div class="t-title--large">Share Listing</div>`,
        modalCssClasses: "modal-dialog c-modal c-modal-gray",
        modalRemote: goingToUrl.href,
      }
    }));
  }
}

